import { useEffect, useMemo, useState } from 'react'
import { useLocation } from 'react-router-dom'

import authApi from '@modules/auth/api'
import { useQuery } from '@tanstack/react-query'

import { useAuthContext } from './useAuthContext'

export const usePendoIntegration = () => {
  const [apiKey, setApiKey] = useState('c005dad2-176c-4e34-7e1b-40f21233f065')
  const [pendoInitialized, setPendoInitialized] = useState(false)

  const { user } = useAuthContext()

  const { data: { data: pendoInfo } = {} } = useQuery({
    queryKey: [authApi.getPendoInfo.key],
    queryFn: () => authApi.getPendoInfo.fn(),
    enabled: !!user,
    retry: false,
  })

  const pendoPayload = useMemo(() => {
    if (!user || !pendoInfo) {
      return null
    }

    const { company, delegate } = pendoInfo

    return {
      visitor: {
        id: user.id,
        email: user.email,
        first_name: user.firstName,
        last_name: user.lastName,
        job_title: delegate?.jobtitle,
        division: delegate?.state?.state,
        country: delegate?.state?.country,
        partneringONEplus_user_level: user.subscriptionLevel,
        'origin-URL': window.location.origin,
      },
      account: {
        id: company?.id,
        company_name: company?.name,
        country: company?.state?.country,
        corporate_email: company?.email,
        website: company?.website,
        state_of_ownership: company?.state?.state,
        main_sector: company?.sector?.sector,
        sub_sector: company?.sector?.subSector,
        primary_therapeutic_areas: company?.areas,
      },
    }
  }, [user, pendoInfo])

  useEffect(() => {
    if (pendoPayload && pendoInitialized) {
      // eslint-disable-next-line @typescript-eslint/ban-ts-comment
      // @ts-ignore
      if (window.pendo) {
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore
        window.pendo.initialize(pendoPayload)
      }
    }
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore
  }, [pendoPayload, window.pendo])

  const location = useLocation()

  useEffect(() => {
    const isSettingsPage = location.pathname === '/plus/settings'
    const isHubPage = location.pathname === '/plus/hub'
    setPendoInitialized(false)

    if (!isSettingsPage) {
      setApiKey(isHubPage ? '91ee9e63-2466-4e86-5b06-95fc8a8bb4fe' : 'c005dad2-176c-4e34-7e1b-40f21233f065')
    }
  }, [location.pathname])

  useEffect(() => {
    const head = document.querySelector('head')
    const existPendoScript = document.querySelector('#pendo-initial-script')
    const existPendoScriptRes = document.querySelector('#pendo-script')
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore
    window.pendo = null
    if (existPendoScript) {
      head?.removeChild(existPendoScript)
    }

    if (existPendoScriptRes) {
      head?.removeChild(existPendoScriptRes)
    }

    const pendoScript = document.createElement('script')
    if (pendoScript) {
      pendoScript.id = 'pendo-initial-script'
      pendoScript.innerHTML = `(function (apiKey) {
      ;(function (p, e, n, d, o) {
        var v, w, x, y, z
        o = p[d] = p[d] || {}
        o._q = o._q || []
        v = ['initialize', 'identify', 'updateOptions', 'pageLoad', 'track']
        for (w = 0, x = v.length; w < x; ++w)
          (function (m) {
            o[m] =
              o[m] ||
              function () {
                o._q[m === v[0] ? 'unshift' : 'push']([m].concat([].slice.call(arguments, 0)))
              }
          })(v[w])
        y = e.createElement(n)
        y.async = !0
        y.src = 'https://cdn.pendo.io/agent/static/' + apiKey + '/pendo.js'
        y.id = 'pendo-script'
        z = e.getElementsByTagName(n)[0]
        z.parentNode.insertBefore(y, z)
      })(window, document, 'script', 'pendo')
    })("${apiKey}")`
      head?.appendChild(pendoScript)
      setPendoInitialized(true)
    }
  }, [apiKey])
}
